import { WidgetIntegration, WidgetIntegrationProvider } from './state';

export enum ActionTypes {
  GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_START = 'GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_START',
  GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_SUCCESS = 'GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_SUCCESS',
  GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_FAILED = 'GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_FAILED',

  ADD_WIDGET_INTEGRATION_START = 'ADD_WIDGET_INTEGRATION_START',
  ADD_WIDGET_INTEGRATION_SUCCESS = 'ADD_WIDGET_INTEGRATION_SUCCESS',
  ADD_WIDGET_INTEGRATION_FAILED = 'ADD_WIDGET_INTEGRATION_FAILURE',

  GET_BLOCK_WIDGET_INTEGRATIONS_START = 'GET_BLOCK_WIDGET_INTEGRATIONS_START',
  GET_BLOCK_WIDGET_INTEGRATIONS_SUCCESS = 'GET_BLOCK_WIDGET_INTEGRATIONS_SUCCESS',
  GET_BLOCK_WIDGET_INTEGRATIONS_FAILED = 'GET_BLOCK_WIDGET_INTEGRATIONS_FAILED',

  REMOVE_BLOCK_WIDGET_INTEGRATIONS = 'REMOVE_BLOCK_WIDGET_INTEGRATIONS',
}

export type GetEnabledWidgetIntegrationProvidersStartAction = {
  type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_START;
};

export type GetEnabledWidgetIntegrationProvidersSuccessAction = {
  type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_SUCCESS;
  coursePath: string;
  enabledWidgetIntegrationProviders: WidgetIntegrationProvider[];
};

export type GetEnabledWidgetIntegrationProvidersFailedAction = {
  type: ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_FAILED;
  error: string;
};

export type AddWidgetIntegrationStartAction = {
  type: ActionTypes.ADD_WIDGET_INTEGRATION_START;
  blockId: string;
};

export type AddWidgetIntegrationSuccessAction = {
  type: ActionTypes.ADD_WIDGET_INTEGRATION_SUCCESS;
  blockId: string;
};

export type AddWidgetIntegrationFailedAction = {
  type: ActionTypes.ADD_WIDGET_INTEGRATION_FAILED;
  blockId: string;
  error: string;
};

export type GetBlockWidgetIntegrationsStartAction = {
  type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_START;
  blockId: string;
};

export type GetBlockWidgetIntegrationsSuccessAction = {
  type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_SUCCESS;
  blockId: string;
  integrations: WidgetIntegration[];
};
export type GetBlockWidgetIntegrationsFailedAction = {
  type: ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_FAILED;
  blockId: string;
  error: string;
};

export type RemoveBlockWidgetIntegrations = {
  type: ActionTypes.REMOVE_BLOCK_WIDGET_INTEGRATIONS;
  blockId: string;
  widgetIntegrationId: string;
};

export type WidgetIntegrationsActions =
  | GetEnabledWidgetIntegrationProvidersFailedAction
  | GetEnabledWidgetIntegrationProvidersStartAction
  | GetEnabledWidgetIntegrationProvidersSuccessAction
  | AddWidgetIntegrationFailedAction
  | AddWidgetIntegrationStartAction
  | AddWidgetIntegrationSuccessAction
  | GetBlockWidgetIntegrationsFailedAction
  | GetBlockWidgetIntegrationsStartAction
  | GetBlockWidgetIntegrationsSuccessAction
  | RemoveBlockWidgetIntegrations;
